import { createAction, props } from '@ngrx/store';
import { IToast, TradeCommentType, IError, OrganizationStatus } from '@shared/models';

export enum ActionTypes {
  OpenModal         = '[UI] Open Modal',
  CloseModal        = '[UI] Close Modal',
  OpenToast         = '[UI] Open Toast',
  CloseToast        = '[UI] Close Toast',
  ChangeFeedFilter  = '[UI] Change Feed Filter',
  SubmitForm        = '[UI] Submit Form',
  SubmitFormSuccess = '[UI] Submit Form Success',
  SubmitFormFail    = '[UI] Submit Form Fail',
  DestroyForm       = '[UI] Destroy Form'
}

export const openModal = createAction(
  ActionTypes.OpenModal,
  props<{ id: string }>()
);

export const closeModal = createAction(
  ActionTypes.CloseModal,
  props<{ id: string }>()
);

export const openToast = createAction(
  ActionTypes.OpenToast,
  props<{ toast: IToast }>()
);

export const closeToast = createAction(
  ActionTypes.CloseToast,
  props<{ id: number }>()
);

export const changeFeedFilter = createAction(
  ActionTypes.ChangeFeedFilter,
  props<{ feedType: TradeCommentType }>()
);

export const submitForm = createAction(
  ActionTypes.SubmitForm,
  props<{ id: string; formValue: any, status?: OrganizationStatus }>()
);

export const submitFormSuccess = createAction(
  ActionTypes.SubmitFormSuccess,
  props<{ id: string }>()
);

export const submitFormFail = createAction(
  ActionTypes.SubmitFormFail,
  props<{ id: string, error: IError }>()
);

export const destroyForm = createAction(
  ActionTypes.DestroyForm,
  props<{ id: string }>()
);

